import './app.scss';
import $ from 'jquery';
import 'bootstrap';
import AOS from 'aos';


$(document).ready(function(){
	AOS.init();

	const $dropdown = $(".dropdown");
	const $dropdownToggle = $(".dropdown-toggle");
	const $dropdownMenu = $(".dropdown-menu");
	const showClass = "show";
	const width = $(window).width();


	$(window).on("load resize", function() {
		if(width < 992){
			$(".dropdown").addClass(showClass);
			$(".dropdown-toggle").attr("aria-expanded", "true");
			$(".dropdown-menu").addClass(showClass);
		}else{
			if (this.matchMedia("(min-width: 768px)").matches) {
				$dropdown.hover(
					function() {
						const $this = $(this);
						$this.addClass(showClass);
						$this.find($dropdownToggle).attr("aria-expanded", "true");
						$this.find($dropdownMenu).addClass(showClass);
					},
					function() {
						const $this = $(this);
						$this.removeClass(showClass);
						$this.find($dropdownToggle).attr("aria-expanded", "false");
						$this.find($dropdownMenu).removeClass(showClass);
					}
					);
			} else {
				$dropdown.off("mouseenter mouseleave");
			}
		}
		
	});
	$(window).on('scroll', function () {
		if ($(this).scrollTop() > 150) {
			$('.go-top').fadeIn(200);
			if (!$('.navbar').hasClass('expand')) {
				$('.navbar').addClass('expand');
				$('#logo').addClass('small')
			}
		} else {
			$('.go-top').fadeOut(200);
			if ($('.navbar').hasClass('expand')) {
				$('.navbar').removeClass('expand');
				$('#logo').removeClass('small');
			}
		}
	});

	$('.go-top').click(function(e){

		e.preventDefault();

		$('html,body').animate({scrollTop: 0}, 300);

	});

	$('.go-to-mujeres').click(function(e){

		e.preventDefault();

		window.location.href = 'mujeres.html';

	});
	$('.go-to-museo').click(function(e){

		e.preventDefault();

		window.location.href = 'museo-del-nacimiento.html';

	});



	
});
console.log('Crea Vida');
